<template>
    <div :class="['selected-player-data', { 'with-image': selectedEpPlayer?.imageUrl }]" v-if="selectedEpPlayer?.id">
        <div class="name-container" v-if="!selectedEpPlayer.imageUrl">
            <i class="fa-duotone fa-solid fa-user"></i>
            <h3>{{ selectedEpPlayer.firstName }} {{ selectedEpPlayer.lastName }} <span v-if="selectedEpPlayer.alternativeName">({{ selectedEpPlayer.alternativeName }})</span></h3>
        </div>
        <div class="name-container" v-if="selectedEpPlayer.imageUrl">
            <img class="selected-player-img" :src="selectedEpPlayer.imageUrl" />
        </div>
        <div class="player-data-rows">
            <div class="player-data-row player-name" v-if="selectedEpPlayer.imageUrl">
                <h3>{{ selectedEpPlayer.firstName }} {{ selectedEpPlayer.lastName }} <span v-if="selectedEpPlayer.alternativeName">({{ selectedEpPlayer.alternativeName }})</span></h3>
            </div>
            <div class="player-data-row">
                <div class="row-item">
                    <p>Nationality: <span>{{ selectedEpPlayer.nationality?.name ?? 'N/A' }}</span></p>
                </div>
                <div class="row-item">
                    <p>Position: <span>{{ selectedEpPlayer.position ?? 'N/A' }}</span></p>
                </div>
            </div>
            <div class="player-data-row">
                <div class="row-item">
                    <p>Date of Birth: <span>{{ selectedEpPlayer.dateOfBirth ? new Date(`${selectedEpPlayer.dateOfBirth}T00:00:00`).toLocaleDateString() : 'N/A' }}</span></p>
                </div>
                <div class="row-item">
                    <p>Age: <span>{{ selectedEpPlayer.age ?? 'N/A' }}</span></p>
                </div>
            </div>
            <div class="player-data-row">
                <div class="row-item">
                    <p>League: <span>{{ selectedEpPlayer.latestStats?.leagueName ?? 'N/A' }}</span></p>
                </div>
                <div class="row-item">
                    <p>Team: <span>{{ selectedEpPlayer.latestStats?.teamName ?? 'N/A' }}</span></p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
         name: 'eliteProspectsPlayerDataComponent',
         props: ['selectedEpPlayer'],
         data() {
            return {
                
            }
         }
    }
</script>

<style>
    @import '/src/assets/css/eliteProspectsPlayerDataComponent.css';
</style>